import React from 'react'
import a3 from '../im/avatarr/avatar-3.png';



import item1 from '../im/items/featured-item-1.png';

import item2 from '../im/items/featured-item-2.png';
import item3 from '../im/items/featured-item-3.png';
import item4 from '../im/items/featured-item-4.png';
import item5 from '../im/items/featured-item-5.png';
import item6 from '../im/items/featured-item-6.png';
import item7 from '../im/items/featured-item-7.png';
import item8 from '../im/items/featured-item-8.png';
import item9 from '../im/items/featured-item-9.png';
import item10 from '../im/items/featured-item-10.png';
import item11 from '../im/items/featured-item-11.png';
import item12 from '../im/items/featured-item-12.png';
import item13 from '../im/items/featured-item-13.png';
import item14 from '../im/items/featured-item-14.png';
import item15 from '../im/items/featured-item-15.png';
import item16 from '../im/items/featured-item-16.png';
import item17 from '../im/items/featured-item-17.png';
import item18 from '../im/items/featured-item-18.png';
import item19 from '../im/items/featured-item-19.png';
import item20 from '../im/items/featured-item-20.png';
import item21 from '../im/items/featured-item-21.png';
import item22 from '../im/items/featured-item-22.png';
import item23 from '../im/items/featured-item-23.png';
import item24 from '../im/items/featured-item-24.png';
import s3 from "../im/slider/s3.png"



function Featured_Creators() {
  return (
    <div>

      <h1 className='display-5 fw-bolder headd  p-5'><span className='text-primary'>Feat</span><span className='text-info'>ured</span> <span className='text-light'>Creators</span></h1>


      <div class=" ">
        <div class="row p-5 gx-5">
          <div class="col-lg-6 p-3 ">
            <div class="row border rounded-9">
              <div class="col-lg-3 d-md-3 d-lg-block d-none  border rounded-9 fc-im">





              </div>
              <div class="col-lg-9 d-md-9 col-sm-12  ">

                <div className='row p-3'>
                  <div className='col-lg-6 col-md-6 col-sm-12'>
                    <h5 className='text-light' >Dexter Stark</h5>
                    <div className=''>
                      <img class="avatar avatar-32 bg-primary rounded-circle text-white p-1"
                        src={a3} /><a href="">

                        <span class="badge rounded-pill badge-notification bg-primary mt-3"><i class="fas fa-check"></i>  </span>
                        <span className='fw-bolder mx-3'> @daGreenGoo</span>
                      </a>
                    </div>



                  </div>
                  <div className='col-lg-3 col-md-3  p-3'>




                  </div>
                  <div className='col-lg-3 col-md-3  p-3 '>
                    <button className='btn rounded-9 border border-primary text-light border-3'>Follow</button>



                  </div>


                </div>
                <div className='p-3'>
                  <h6 className=''><a className='border rounded-9 p-1 ' href=""><i class="fab fa-facebook-square p-1 mx-1 "></i></a> <a className='border rounded-9 p-1 mx-3' href=""><i class="fab fa-twitter  p-1 mx-1"></i></a><a className='border rounded-9 p-1 mx-1' href=""><i class="fab fa-instagram p-1 mx-1 "></i></a><a className='border rounded-9 p-1 mx-3' href=""><i class="fas fa-paperclip p-1 mx-1 "></i></a>   <a className='border rounded-9 p-1 mx-1' href=""><i class="fab fa-twitter  p-1 mx-1"></i></a>



                    <h6 className='text-light my-5 lh'>I’m a graphic designer and illustrator from Mexico City. Since 2 years ago I specialize on big mural pieces and street art that you can find in countries all around the world!</h6>


                  </h6>



                </div>


                <div className=' table-responsive p-3'>
                  <table class="table table-borderless text-light table-sm ">
                    <thead>
                      <tr >
                        <th scope="col"><h4 className='fw-bolder'>12.3K</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>7.2k</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>135</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>9</h4></th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row"><h6 className='fw-bolder'>Followers</h6></th>
                        <td><h6 className='fw-bolder'>Following</h6></td>
                        <td><h6 className='fw-bolder'>Created</h6></td>
                        <td><h6 className='fw-bolder'>On Sale</h6></td>
                      </tr>


                    </tbody>
                  </table>
                </div>

                <div style={{borderBottom:'none'}} className=' table p-3'>
                  <table style={{borderColor:'black'}} class="table table-borderless text-light table-sm ">
                    <thead>

                      <tr >
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item1} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item2} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item3} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item4} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 border text-white rounded-4 ">...</span></h4></th>




                      </tr>
                    </thead>

                  </table>
                </div>




              </div>

            </div>






          </div>
          <div class="col-lg-6 p-3">
            <div class="row border rounded-9">
              <div class="col-lg-3 d-md-3 d-lg-block d-none  border rounded-9 fc-im">





              </div>
              <div class="col-lg-9 d-md-9 col-sm-12  ">

                <div className='row p-3'>
                  <div className='col-lg-6 col-md-6 col-sm-12'>
                    <h5 className='text-light' >Dexter Stark</h5>
                    <div className=''>
                      <img class="avatar avatar-32 bg-primary rounded-circle text-white p-1"
                        src={a3} /><a href="">

                        <span class="badge rounded-pill badge-notification bg-primary mt-3"><i class="fas fa-check"></i>  </span>
                        <span className='fw-bolder mx-3'> @daGreenGoo</span>
                      </a>
                    </div>



                  </div>
                  <div className='col-lg-3 col-md-3  p-3'>




                  </div>
                  <div className='col-lg-3 col-md-3  p-3 '>
                    <button className='btn rounded-9 border border-primary text-light border-3'>Follow</button>



                  </div>


                </div>
                <div className='p-3'>
                  <h6 className=''><a className='border rounded-9 p-1 ' href=""><i class="fab fa-facebook-square p-1 mx-1 "></i></a> <a className='border rounded-9 p-1 mx-3' href=""><i class="fab fa-twitter  p-1 mx-1"></i></a><a className='border rounded-9 p-1 mx-1' href=""><i class="fab fa-instagram p-1 mx-1 "></i></a><a className='border rounded-9 p-1 mx-3' href=""><i class="fas fa-paperclip p-1 mx-1 "></i></a>   <a className='border rounded-9 p-1 mx-1' href=""><i class="fab fa-twitter  p-1 mx-1"></i></a>



                    <h6 className='text-light my-5 lh'>I’m a graphic designer and illustrator from Mexico City. Since 2 years ago I specialize on big mural pieces and street art that you can find in countries all around the world!</h6>


                  </h6>



                </div>


                <div className=' table-responsive p-3'>
                  <table class="table table-borderless text-light table-sm ">
                    <thead>
                      <tr >
                        <th scope="col"><h4 className='fw-bolder'>12.3K</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>7.2k</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>135</h4></th>
                        <th scope="col"><h4 className='fw-bolder'>9</h4></th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th scope="row"><h6 className='fw-bolder'>Followers</h6></th>
                        <td><h6 className='fw-bolder'>Following</h6></td>
                        <td><h6 className='fw-bolder'>Created</h6></td>
                        <td><h6 className='fw-bolder'>On Sale</h6></td>
                      </tr>


                    </tbody>
                  </table>
                </div>

                <div className=' table-responsive p-3'>
                  <table class="table table-borderless text-light table-sm ">
                    <thead>

                      <tr >
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item1} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item2} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item3} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 bg-secondary text-white rounded-2 "> <img src={item4} className=''></img></span></h4></th>
                        <th scope="col"><h4 className='fw-bolder'>
                          <span class="avatar avatar-48 border text-white rounded-4 ">...</span></h4></th>




                      </tr>
                    </thead>

                  </table>
                </div>




              </div>

            </div>
          </div>
        </div>
      </div>
      <div className='p-5 '>

        <div className='col bcme-cre1  p-3 border rounded-9 bg bcme-cre2'  >
         
          <div className='row '>
          <div className='col-lg-1 d-none d-lg-block'>
        



            </div>
            <div className='col-lg-6 col-md-6 col-sm-12 text-light p-5'>
              <div className=''>
            <h6 className='fw-bold'>COME AND JOIN THEM!</h6>
            <h3 className='fw-bold'>BECOME A CREATERS</h3>
            </div>



            </div>
            <div className='col-lg-5 col-md-6 col-sm-12 text-center align-self-center'>

            <a href="/"><button className="bnn632-hover bn19">start selling</button></a>
          
        



            </div>

            

          </div>

        </div>

      </div>
    </div>
  )
}

export default Featured_Creators
